module.exports = __webpack_public_path__ + "static/app-store-0d71b34cb29123582305bd3b0ecf6dd6.svg";